import { ThankYouView } from "../../../components/ThankYou/ThankYouView";
import { useMetadata } from "components/Signup/store/selectors/metadata";
import {
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";
import { useLeadAllianceTracking } from "components/Signup/components/ThankYou/useLeadAllianceTracking";

const ThankYou = () => {
  const animals = useAllValidAnimals();
  const { species } = useCurrentAnimal();
  const { purchaseCompleted } = useMetadata();

  useLeadAllianceTracking({
    animals,
    purchaseCompleted,
    productId: `${species}-health`,
  });

  return <ThankYouView showMultipetBanner showTractiveBanner />;
};

export default ThankYou;
